import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagFlat = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.1429)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.83228 17.9375V10.0625M6.83228 10.0625V4.8125C6.83228 3.846 7.61578 3.0625 8.58228 3.0625H13.2915C13.942 3.0625 14.365 3.74702 14.0741 4.32881L13.1529 6.17119C13.0298 6.41752 13.0298 6.70748 13.1529 6.95381L14.0741 8.79619C14.365 9.37798 13.942 10.0625 13.2915 10.0625H6.83228Z",
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgFlagFlat);
export default ForwardRef;
